import { httpService } from "../http";
const REACT_APP_GO_MICRO = process.env.REACT_APP_GO_MICRO;

export interface CouponItem {
  cardIcon: string;
  couponCardCode: string;
  couponCardId: string;
  couponCardQrcodeText: string;
  couponCardType: string;
  endTime: string;
  startTime: string;
  title: string;
  usedStatus: number;
  userId: number;
  couponCardQrcodeBase64: string;
  description?: string;
}
/// 券详情详情
export const fetchCouponDetail = async (param: { couponCardId: string }): Promise<{ couponInfo: CouponItem; description: string }> => {
  return httpService.get(`/mp2c-micro/coupon-card/info`, param, { baseURL: REACT_APP_GO_MICRO });
}
